<template>
    <div class="peering-list-container init">
        <div class="cps-page-top">
            <div class="jc-page-header">
                <el-page-header :title="$t('peering.text.connection')" />
                <div class="jc-box-action">
                    <a :href="Config.PEERING_HELP_URL" target="_blank">
                        {{ $t('peering.help.doc') }}
                    </a>
                </div>
            </div>
            <div class="jc-page-content">
                <div class="jc-container-table">
                    <div class="jc-container-table-actionBar flex-display">
                        <!--刷新、地域、申请-->
                        <el-form class="jc-table-actionBar-item" :inline="true">
                            <el-form-item>
                                <el-button icon="jc-icon-refresh-line" class="jc-button-icon"
                                    @click="updateList('refresh')">
                                </el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-radio-group v-model="region" @change="regionChange">
                                    <el-radio-button v-for="(area, index) in regions" :key="index" :label="area.region">
                                        {{ area.regionName }}
                                    </el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item>
                                <el-tooltip placement="right" :disabled="cpsVip">
                                    <div slot="content">
                                        {{ $t('peering.help.hasNoCpsVip') }}
                                        <a :href="Config.WORK_URL" target="_blank">
                                            {{ $t("peering.help.submitWorkOrder") }}
                                        </a>
                                        {{ $t("peering.help.applyCpsVip") }}
                                    </div>
                                    <span @click="jumpToCreate" class="el-button create-button"
                                        :class="!cpsVip ? 'is-disabled' : ''">
                                        {{ $t("peering.text.create") }}
                                    </span>
                                </el-tooltip>
                            </el-form-item>
                        </el-form>
                        <!--搜索、自定义、下载-->
                        <el-form class="jc-box-table-search" :inline="true" @submit.native.prevent>
                            <el-form-item>
                                <el-input v-entire-placeholder @keyup.enter.native="updateList('refresh')"
                                    :placeholder="currentPlaceholder" v-model.trim="currentSearchValue" style="width:412px">
                                    <el-select v-select-auto-width.nomargin slot="prepend" id="my-select"
                                        v-model="currentSearch" @change="changeSearch">
                                        <el-option class="my-select-input" v-for="item in PeeringSearchConditions"
                                            :key="item.searchValue" :label="item.searchLabel" :value="item.searchValue">
                                        </el-option>
                                    </el-select>
                                    <el-button slot="append" icon="jc-icon-search" class="search-icon"
                                        @click="updateList('refresh')"></el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-setting" class="jc-button-icon cps-custom-icon"
                                    @click="customVisible = true" :title="$t('listPage.text.customList')"></el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button class="jc-button-icon cps-custom-icon" icon="jc-icon-download"
                                    @click="exportList" :title="$t('listPage.text.exportList')"></el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <!--对等连接列表-->
                    <el-table :data="tableData" style="width:100%" class="jc-list-table jc-table-header-cell"
                        ref="listTable" @filter-change="filterChange" :empty-text="$t('speechCraft.listEmptyText')"
                        v-loading="refreshLoading">
                        <!--ID/名称-->
                        <el-table-column :label="$t('sbw.text.idOrName')" min-width="200" key="name"
                            v-if="customInfo !== null && customInfo['name'] && customInfo['name'].selected">
                            <template slot-scope="scope">
                                <!--ID-->
                                <el-tooltip class="item" effect="dark" :content="scope.row.peerIden" placement="bottom">
                                    <span>{{ scope.row.peerIden | maybeEmpty }}</span>
                                </el-tooltip>
                                <br />
                                <!--实例名称-->
                                <el-tooltip class="item" effect="dark" :content="scope.row.name" placement="bottom">
                                    <a href="javascript:void(0)" @click="jumpToDetail(scope.row.peerIden, region)">
                                        {{ scope.row.name | maybeEmpty }}
                                    </a>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <!--状态-->
                        <el-table-column :filter-multiple="true" column-key="status" :filters="filters.status"
                            :label="$t('peering.text.status')" key="status" prop="status"
                            v-if="customInfo !== null && customInfo['status'] && customInfo['status'].selected" width="90">
                            <template slot-scope="scope">
                                <span :class="PeeringStatusClass[scope.row.status]">
                                    {{ scope.row.statusZh }}
                                </span>
                            </template>
                        </el-table-column>
                        <!--本端地域-->
                        <el-table-column prop="senderRegion" min-width="70" key="senderRegion"
                            :label="$t('peering.text.localRegion')"
                            v-if="customInfo !== null && customInfo['senderRegion'] && customInfo['senderRegion'].selected">
                            <template slot-scope="scope">
                                <span>{{ scope.row.localRegionName }}</span>
                            </template>
                        </el-table-column>
                        <!--本端私有网络-->
                        <el-table-column prop="localVpcName" min-width="140" key="localVpcName"
                            :label="$t('peering.text.localVpc')"
                            v-if="customInfo !== null && customInfo['localVpcName'] && customInfo['localVpcName'].selected">
                            <template slot-scope="scope">
                                <a href="javascript:void(0)"
                                    @click="jumpToVpcDetail(scope.row.localVpcIden, scope.row.localVpcName)">{{
                                        scope.row.localVpcName
                                        | maybeEmpty }}</a>
                                <p>{{ scope.row.localVpcIpv4Cidr | formatEmptyFilter }}(IPv4 CIDR)</p>
                                <p>{{ scope.row.localVpcIpv6Cidr | formatEmptyFilter }}(IPv6 CIDR)</p>
                            </template>
                        </el-table-column>
                        <!--对端地域-->
                        <el-table-column prop="receiverRegion" min-width="70" key="receiverRegion"
                            :label="$t('peering.text.oppositeRegion')"
                            v-if="customInfo !== null && customInfo['receiverRegion'] && customInfo['receiverRegion'].selected">
                            <template slot-scope="scope">
                                <span>{{ scope.row.remoteRegionName }}</span>
                            </template>
                        </el-table-column>
                        <!--对端私有网络-->
                        <el-table-column prop="remoteVpcName" min-width="140" key="remoteVpcName"
                            :label="$t('peering.text.oppositeVpc')"
                            v-if="customInfo !== null && customInfo['remoteVpcName'] && customInfo['remoteVpcName'].selected">
                            <template slot-scope="scope">
                                <p> {{ scope.row.remoteVpcName | maybeEmpty }}</p>
                                <p>{{ scope.row.remoteVpcIpv4Cidr | formatEmptyFilter }}(IPv4 CIDR)</p>
                                <p>{{ scope.row.remoteVpcIpv6Cidr | formatEmptyFilter }}(IPv6 CIDR)</p>
                            </template>
                        </el-table-column>
                        <!--对端账号-->
                        <el-table-column prop="az" min-width="90" key="az" :label="$t('peering.text.oppositeAccountNumber')"
                            v-if="customInfo !== null && customInfo['account'] && customInfo['account'].selected">
                            <template slot-scope="scope">
                                <p v-if="SameTenant[scope.row.account]">{{ $t('peering.text.sameAccount') }}</p>
                                <p v-else>{{ scope.row.account | maybeEmpty }}</p>
                            </template>
                        </el-table-column>
                        <!--带宽上限-->
                        <el-table-column width="100" key="bandwidth" prop="bandwidth" :label="$t('eip.text.bandwidthLimit')"
                            v-if="customInfo !== null && customInfo['bandwidth'] && customInfo['bandwidth'].selected">
                            <template slot-scope="scope">
                                <span class="english-wrap">
                                    {{ SameRegion[scope.row.isSameRegion] ? $t("peering.text.noLimit") : scope.row.bandwidth
                                        + "Mbps" }}
                                </span>
                                <p v-if="!SameRegion[scope.row.isSameRegion]">
                                    {{ $t("eip.text.independentBandwidth") }}
                                </p>
                            </template>
                        </el-table-column>
                        <!--计费信息-->
                        <el-table-column key="charge" min-width="80" :label="$t('listPage.tableLabel.billingInformation')"
                            v-if="customInfo !== null && customInfo['fee'] && customInfo['fee'].selected">
                            <template slot-scope="scope">
                                <div v-if="SameRegion[scope.row.isSameRegion]">
                                    {{ $t('peering.text.free') }}
                                </div>
                                <div v-else>
                                    <!--跨账号跨地域接收端特殊处理-->
                                    <template v-if="accountRolesStatus(scope.row) === 7">
                                        {{ $t('peering.text.paymentByInitiator') }}
                                    </template>
                                    <template v-else>
                                        <p>
                                            {{ transformCharge(scope.row.charge.chargeMode) }}
                                            <span v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus)"
                                                class="expire-warning">
                                                {{ '(' + $t('privateNetInstance.arrear') + ')' }}
                                            </span>
                                        </p>
                                        <p class="list-expire-p bill-info-tip"
                                            v-if="scope.row.charge.chargeStatus === 'normal'">
                                            {{ scope.row.charge.chargeStartTime + ' ' + $t('privateNetInstance.create') }}
                                        </p>
                                        <p class="list-expire-p expire-warning"
                                            v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus) && scope.row.charge.chargeRetireTime">
                                            {{ scope.row.charge.chargeRetireTime + ' ' + $t('listPage.text.freed') }}
                                        </p>
                                    </template>
                                </div>
                            </template>
                        </el-table-column>
                        <!--操作-->
                        <el-table-column width="100" key="operation" :label="$t('listPage.tableLabel.operation')"
                            v-if="customInfo !== null && customInfo['operation'] && customInfo['operation'].selected">
                            <template slot-scope="scope">
                                <!--同账号同地域发起端-->
                                <div v-if="accountRolesStatus(scope.row) === 1">
                                    <a href="javascript:void(0)" class="cps-select-form-item"
                                        @click="selectOpts(PeeringOperationConstant.DELETE, scope.row)">
                                        {{ $t('peering.text.delete') }}
                                    </a>
                                </div>
                                <!--跨账号同地域发起端-->
                                <div v-else-if="accountRolesStatus(scope.row) === 2">
                                    <a href="javascript:void(0)" class="cps-select-form-item"
                                        :class="{ 'cps-dropdown-disabled': !scope.row.chargeStatus }"
                                        @click="selectOpts(PeeringOperationConstant.DELETE, scope.row, !scope.row.chargeStatus)">
                                        {{ $t('peering.text.delete') }}
                                    </a>
                                </div>
                                <!--同账号跨地域发起端-->
                                <div v-else-if="accountRolesStatus(scope.row) === 3">
                                    <a href="#" @click="openModifyBandwidthDialog(scope.row)"
                                        :class="{ 'cps-dropdown-disabled': OverdueConstantArray.includes(scope.row.chargeStatus) || !scope.row.chargeStatus }">
                                        {{ $t('eip.text.modifyBandwidth') }}
                                    </a>
                                    <a href="javascript:void(0)" class="cps-select-form-item"
                                        :class="{ 'cps-dropdown-disabled': !scope.row.chargeStatus }"
                                        @click="selectOpts(PeeringOperationConstant.DELETE, scope.row, !scope.row.chargeStatus)">
                                        {{ $t('peering.text.delete') }}
                                    </a>
                                </div>
                                <!--跨账号跨地域发起端-->
                                <div v-else-if="accountRolesStatus(scope.row) === 4">
                                    <template v-if="scope.row.status !== 'rejected'">
                                        <a href="#" @click="openModifyBandwidthDialog(scope.row)"
                                            :class="{ 'cps-dropdown-disabled': OverdueConstantArray.includes(scope.row.chargeStatus) || !scope.row.chargeStatus }">
                                            {{ $t('eip.text.modifyBandwidth') }}
                                        </a>
                                        <a href="javascript:void(0)" class="cps-select-form-item"
                                            :class="{ 'cps-dropdown-disabled': !scope.row.chargeStatus }"
                                            @click="selectOpts(PeeringOperationConstant.DELETE, scope.row, !scope.row.chargeStatus)">
                                            {{ $t('peering.text.delete') }}
                                        </a>
                                    </template>
                                    <template v-else>
                                        <a href="javascript:void(0)" class="cps-select-form-item"
                                            :class="{ 'cps-dropdown-disabled': !scope.row.chargeStatus }"
                                            @click="selectOpts(PeeringOperationConstant.DELETE, scope.row, !scope.row.chargeStatus)">
                                            {{ $t('peering.text.delete') }}
                                        </a>
                                    </template>
                                </div>
                                <!--跨账号同地域接收端-->
                                <div v-else-if="accountRolesStatus(scope.row) === 5">
                                    <template v-if="scope.row.status === 'applied'">
                                        <a href="javascript:void(0)" class="cps-select-form-item"
                                            @click="selectOpts(PeeringOperationConstant.ACCEPT, scope.row)">
                                            {{ $t('peering.text.accept') }}
                                        </a>
                                        <a href="javascript:void(0)" class="cps-select-form-item"
                                            @click="selectOpts(PeeringOperationConstant.REJECT, scope.row)">
                                            {{ $t('peering.text.reject') }}
                                        </a>
                                    </template>
                                    <template v-else>
                                        <a href="javascript:void(0)" class="cps-select-form-item"
                                            :class="{ 'cps-dropdown-disabled': !scope.row.chargeStatus }"
                                            @click="selectOpts(PeeringOperationConstant.DELETE, scope.row, !scope.row.chargeStatus)">
                                            {{ $t('peering.text.delete') }}
                                        </a>
                                    </template>
                                </div>
                                <!--同账号跨地域接收端-->
                                <div v-else-if="accountRolesStatus(scope.row) === 6">
                                    <a href="javascript:void(0)" class="cps-select-form-item"
                                        :class="{ 'cps-dropdown-disabled': !scope.row.chargeStatus }"
                                        @click="selectOpts(PeeringOperationConstant.DELETE, scope.row, !scope.row.chargeStatus)">
                                        {{ $t('peering.text.delete') }}
                                    </a>
                                </div>
                                <!--跨账号跨地域接收端-->
                                <div v-else-if="accountRolesStatus(scope.row) === 7">
                                    <!-- 已接受 -->
                                    <template v-if="scope.row.status === 'applied'">
                                        <a href="javascript:void(0)" class="cps-select-form-item"
                                            @click="selectOpts(PeeringOperationConstant.ACCEPT, scope.row)">
                                            {{ $t('peering.text.accept') }}
                                        </a>
                                        <a href="javascript:void(0)" class="cps-select-form-item"
                                            @click="selectOpts(PeeringOperationConstant.REJECT, scope.row)">
                                            {{ $t('peering.text.reject') }}
                                        </a>
                                    </template>
                                    <!--  -->
                                    <template v-else>
                                        <!-- <a href="javascript:void(0)" class="cps-select-form-item"
                                            :class="{ 'cps-dropdown-disabled': !scope.row.chargeStatus }"
                                            @click="selectOpts(PeeringOperationConstant.DELETE, scope.row, !scope.row.chargeStatus)">
                                            {{ $t('peering.text.delete') }}
                                        </a> -->
                                        <a href="javascript:void(0)" class="cps-select-form-item"
                                            @click="selectOpts(PeeringOperationConstant.DELETE, scope.row, false)">
                                            {{ $t('peering.text.delete') }}
                                        </a>
                                    </template>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <custom :visible.sync="customVisible" v-if="customVisible" :optionArr="optionArr" :type="type">
            </custom>
            <!--调整带宽-->
            <modify-bandwidth :dialog-visible="modifyDialogVisible" @ifDialogVisible="syncModifyDialog"
                :detail-data="currentRow" pageType="PEERING">
            </modify-bandwidth>
        </div>
        <div ref="footer" class="cps-page-footer" v-if="total">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {
    PeeringSearchConditions,
    PeeringStatusClass,
    SameTenant,
    SameRegion,
    AccountRoles,
    PeeringOperationConstant,
    ChargeModeConstant,
    OverdueConstantArray,
    ArrearConstantArray,
    ServiceCodeConstant,
    ChargeModeMap
} from '@/common/Constants';
import {
    initialPage,
    initialPageSize,
    emptyValue,
} from '@/common/ConstParam';

import { getListPeerings, getPeeringStatus } from '@/api/peering/list/actions';
import peeringOperations from '@/common/PeeringPopHelper';
import { deepCopy, compose } from '@/common/tool';
import Custom from '@/components/common/custom/Custom';
import ModifyBandwidth from '@/components/common/modifyBandwidth/ModifyBandwidth';
import ifVip from '@/mixins/ifVip'
import isDestroyingMixins from '@/mixins/isDestroying';
export default {
    name: 'PeeringList',
    mixins: [ifVip, isDestroyingMixins],
    components: {
        Custom,
        ModifyBandwidth,
    },
    data() {
        this.PeeringStatusClass = PeeringStatusClass;
        this.SameTenant = SameTenant;
        this.SameRegion = SameRegion;
        this.AccountRoles = AccountRoles;
        this.PeeringSearchConditions = PeeringSearchConditions;
        this.ServiceCodeConstant = ServiceCodeConstant;
        this.PeeringOperationConstant = PeeringOperationConstant
        this.ChargeModeConstant = ChargeModeConstant;
        this.ChargeModeMap = ChargeModeMap;
        this.OverdueConstantArray = OverdueConstantArray;
        this.ArrearConstantArray = ArrearConstantArray;
        return {
            regions: [
            ],
            region: emptyValue,
            currentSearch: 'peeringName',
            // 当前搜索input框值
            currentSearchValue: emptyValue,
            // 当前搜索条件对应placeholder
            currentPlaceholder: this.$t('peering.placeholder.search.peeringName'),
            filters: {
                status: []
            },
            filterParams: {
                status: emptyValue
            },
            refreshLoading: false,
            tableData: [],
            currentPage: initialPage,
            pageSize: initialPageSize,
            pageSizes: [20, 50, 100], // 可选每页展示多少条
            total: 0,
            // 自定义列表是否显示
            customVisible: false,
            // 自定义列表表头
            optionArr: [
                {
                    // ID/名称
                    label: this.$t('sbw.text.idOrName'),
                    value: 'name'
                },
                {
                    // 状态
                    label: this.$t('peering.text.status'),
                    value: 'status'
                },
                {
                    // 本端地域
                    label: this.$t('peering.text.localRegion'),
                    value: 'senderRegion'
                },
                {
                    // 本端私有网络
                    label: this.$t('peering.text.localVpc'),
                    value: 'localVpcName'
                },
                {
                    // 对端地域
                    label: this.$t('peering.text.oppositeRegion'),
                    value: 'receiverRegion'
                },
                {
                    // 对端账号
                    label: this.$t('peering.text.oppositeAccountNumber'),
                    value: 'account'
                },
                {
                    // 对端私有网络
                    label: this.$t('peering.text.oppositeVpc'),
                    value: 'remoteVpcName'
                },
                {
                    // 带宽上限
                    label: this.$t('eip.text.bandwidthLimit'),
                    value: 'bandwidth'
                },
                {
                    // 计费信息
                    label: this.$t('list.chargeInfo'),
                    value: 'fee'
                },
                {
                    // 操作
                    label: this.$t('listPage.tableLabel.operation'),
                    value: 'operation'
                }
            ],
            // 自定义列表类型
            type: "peerConnList",
            // 修改带宽弹框是否可见
            modifyDialogVisible: false,
            // 删除共享带宽弹框是否可见
            deleteDialogVisible: false,
            // 当前行所有数据
            currentRow: {},
            statusTimeOut: null, // 刷新列表定时器
        };
    },
    computed: {
        customInfo() {
            return this.$store.state.customInfo[this.type];
        },
        // 对等连接登陆用户角色状态
        accountRolesStatus() {
            return (row) => {
                let status;
                // 同账号同地域发起端
                if (this.SameTenant[row.isSameTenant] && this.SameRegion[row.isSameRegion] && row.accountType === this.AccountRoles.sender) {
                    status = 1;
                }
                // 跨账号同地域发起端
                if (!this.SameTenant[row.isSameTenant] && this.SameRegion[row.isSameRegion] && row.accountType === this.AccountRoles.sender) {
                    status = 2;
                }
                // 同账号跨地域发起端
                if (this.SameTenant[row.isSameTenant] && !this.SameRegion[row.isSameRegion] && row.accountType === this.AccountRoles.sender) {
                    status = 3;
                }
                // 跨账号跨地域发起端
                if (!this.SameTenant[row.isSameTenant] && !this.SameRegion[row.isSameRegion] && row.accountType === this.AccountRoles.sender) {
                    status = 4;
                }
                // 跨账号同地域接收端
                if (!this.SameTenant[row.isSameTenant] && this.SameRegion[row.isSameRegion] && row.accountType === this.AccountRoles.receiver) {
                    status = 5;
                }
                // 同账号跨地域接收端
                if (this.SameTenant[row.isSameTenant] && !this.SameRegion[row.isSameRegion] && row.accountType === this.AccountRoles.receiver) {
                    status = 6;
                }
                // 跨账号跨地域接收端
                if (!this.SameTenant[row.isSameTenant] && !this.SameRegion[row.isSameRegion] && row.accountType === this.AccountRoles.receiver) {
                    status = 7;
                }
                return status
            }
        }
    },
    watch: {
        region(newValue) {
            if (newValue) {
                this.regionChange()
            }
        },
    },
    async created() {
        if (this.customInfo === null) {
            this.getCustomInfo();
        }
        this.queryPeeringStatus();
        const regions = await this.getRegions();
        const dealRegions = compose(this.setRegion, this.setRegions);
        const dealVip = compose(this.setVip, dealRegions);
        dealVip(regions);
    },
    destroyed() {
        clearTimeout(this.statusTimeOut);
    },
    mounted() {
    },
    methods: {

        setVip(region) {
            this.getUserIfVip({
                region
            });
        },
        // 切换可用区
        regionChange() {
            this.currentSearchValue = emptyValue;
            this.pageSize = initialPageSize;
            this.currentPage = initialPage;
            this.currentSearch = 'peeringName';
            this.updateList();
        },
        // 获得可用区
        getRegions() {
            const params = {
                networkType: 'vpc'
            };
            return Ajax.get('api/cps/getRegions', params).then((res) => {
                return res.data && res.data.regions
            });
        },
        setRegions(regions) {
            return this.regions = regions.map(item => {
                return {
                    region: item.region,
                    regionName: item.regionName
                }
            });
        },
        setRegion(regions) {
            return this.region = this.$route.query.region || regions.filter((item, index) => index === 0).reduce((grandTotal, current) => current.region, '');
        },
        getRegionName(region) {
            return this.regions.filter(item => region === item.region).reduce((grandTotal, current) => current.regionName, '');
        },
        queryPeeringStatus() {
            getPeeringStatus().then(res => {
                this.filters.status = res.data.peerConnStatus.map((item, index) => {
                    // 特殊处理待接收的value值，依赖于后端返回值索引,vaule值与列表status对应
                    if (index === 1) {
                        item.value = "accepting";
                    }
                    return {
                        text: item.name,
                        value: item.value
                    }
                });
            })
        },
        filterStatus(value, row) {
            console.log(value);
            // if(value.indexOf(',')){
            // 	if(row.status === value.substr(0,value.indexOf(','))){
            // 		return true
            // 	}
            // 	if(row.status === value.substr(value.indexOf(',')+1,value.length)){
            // 		return true
            // 	}
            // 	return false
            // }
            //   	return row.status === value;
        },
        // 获取对等连接列表
        getPeeringsData() {
            if (this.isDestroying) {
                return
            }
            // 基础参数
            const param = {
                region: this.region,
                pageNumber: this.currentPage,
                pageSize: this.pageSize,
                status: this.filterParams.status
            };
            // 搜索部分添加参数
            if (this.currentSearchValue) {
                switch (this.currentSearch) {
                    case 'peeringName': {
                        param.peeringName = this.currentSearchValue;
                        break;
                    }
                    case 'peeringId': {
                        param.peeringId = this.currentSearchValue;
                        break;
                    }
                    default:
                        break;
                }
            }
            getListPeerings(param)
                .then(res => {
                    const list = res.data.peerConnList;
                    this.tableData = list.map(item => {
                        item.chargeMode = item.charge.chargeMode;
                        item.chargeModeName = item.charge.chargeMode ? this.ChargeModeMap[item.charge.chargeMode.toUpperCase()] : '';
                        item.expire = item.charge.chargeExpiredTime;
                        item.retireTime = item.charge.chargeRetireTime;
                        item.chargeStatus = item.charge.chargeStatus;
                        // status字段中间层透传，前端处理区分申请中、待接收,发送端校正为accepting
                        if (item.status === "applied" && item.accountType === 0) {
                            item.status = "accepting";
                        }
                        return item
                    });
                    this.total = res.data.totalCount;
                    const refreshTag = this.tableData.some(item => (item.status === "initializing" || item.status === "accepting" || item.status === "applied"));
                    if (refreshTag) {
                        clearTimeout(this.statusTimeOut);
                        this.statusTimeOut = setTimeout(() => {
                            this.getPeeringsData();
                        }, 5000);
                    }
                })
                .catch(async (err) => {
                    const { response } = err.data;
                    try {
                        const json = await response.json();
                        // this.$message.error(json.errmsg);
                        this.tableData = [];
                        this.total = 0;
                    } catch (ex) {
                        console.log(ex);
                    }
                }).finally(() => {
                    this.refreshLoading = false;
                });
        },
        updateList(type) {
            if (type === 'refresh') {
                this.currentPage = initialPage;
                this.refreshLoading = true;
            }
            this.getPeeringsData();
        },

        refresh() {
            this.updateList('refresh')
        },

        // 跳转到vpc详情页
        jumpToVpcDetail(id, vpcName) {
            this.$router.push({
                path: '/vpc/detail',
                query: {
                    region: this.region,
                    vpcName,
                    tabName: "source",
                    id
                }
            });
        },
        // 跳转到详情页
        jumpToDetail(id, region) {
            this.$router.push({
                path: `/peering/detail/${id}/${region}`,
                query: {
                    regionName: this.getRegionName(region),
                    tabName: 'source'
                }
            });
        },
        // 跳转到创建页
        jumpToCreate() {
            if (!this.cpsVip) {
                return
            }
            this.$router.push({
                path: '/peering/create',
                query: {
                    region: this.region
                }
            });
        },
        // 修改搜索条件
        changeSearch() {
            const searchPlaceholder = this.$t('peering.placeholder.search');
            const currentSearchVar = this.currentSearch;
            this.currentPlaceholder = searchPlaceholder[currentSearchVar];
            // 清空当前搜索条件
            this.currentSearchValue = emptyValue;
        },
        // 导出列表接口
        exportList() {
            let temp = '';
            if (this.currentSearchValue) {
                switch (this.currentSearch) {
                    case 'peeringName': {
                        temp = `&peeringName=${this.currentSearchValue}`;
                        break;
                    }
                    case 'peeringId': {
                        temp = `&peeringId=${this.currentSearchValue}`;
                        break;
                    }
                    default:
                        break;
                }
            }
            const url = `/cps_api/api/export/exportPeerConns?pageNumber=${this.currentPage}&pageSize=${this.pageSize}&region=${this.region}${temp}&status=${this.filterParams.status}`;
            window.open(url, "_self");
        },
        // 切换每一页多少条
        handleSizeChange(val) {
            this.pageSize = val;
            this.updateList('refresh');
        },
        // 切换当前页
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getPeeringsData();
        },
        getCustomInfo() {
            const param = {
                pageKey: this.type
            };

            Ajax.get('/api/usercenter/getCustomInfo', param).then((res) => {
                let customInfo = res.data.customInfo;
                if (Object.keys(customInfo).length) {
                    this.$store.commit('GET_CUSTOMINFO', { value: res.data.customInfo, type: this.type });
                }
            }).catch(err => {
                console.log(err)
            });
        },
        openModifyBandwidthDialog(row) {
            if (OverdueConstantArray.includes(row.chargeStatus) || !row.chargeStatus) {
                return false;
            }
            this.currentRow = row;
            this.modifyDialogVisible = true;
        },
        // 同步修改带宽子组件传出来的dialog是否显示
        syncModifyDialog(data) {
            this.modifyDialogVisible = data;
        },

        // 操作
        selectOpts(caseOps, row, disabled, otherDisabled) {
            if (disabled || otherDisabled) {
                return;
            }
            peeringOperations(caseOps, this, row, 'list');
        },

        filterChange(filter) {
            this.currentPage = 1;
            Object.keys(filter).map((key) => {
                if (key === 'status') {
                    this.filterParams.status = filter[key].toString().replace('accepting', 'applied');
                }
            });
            this.refreshLoading = true;
            this.getPeeringsData();
        },

        transformCharge(payMethod) {
            switch (payMethod) {
                case 'prepaid_by_duration':
                    return this.$t('privateNetInstance.monthAndYear');
                case 'postpaid_by_duration':
                    return this.$t('create.text.byConfigurations');
                default:
                    return '';
            }
        },
    }
};
</script>


<style lang="scss">
@import '../../../assets/scss/listComon.scss';
@import '../../../assets/scss/paginationCommon.scss';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/peering/list/List.vue